<div class="warp-reminder">
    <div class="warp-contain">
        <div class="title">
            <p>-</p>
            <p translate>reminder.title</p>
        </div>
        <P class="mini-title" translate>reminder.timing</P>
        <div class="times">
            <input type="date" class="date" placeholder="25.10.2023" [formControl]="reminderForm.controls.startDate">
            <img class="repeat-img hour" src="/assets/images/reminder/hour.svg">
            <select [formControl]="reminderForm.controls.hour">
                <option *ngFor="let c of hourers$ | async " [ngValue]="c.id" class="op">
                    <div>{{c.hour}}:00</div>
                    <!-- {{c.minutes}} -->
                </option>
            </select>
            <img class="repeat-img" src="/assets/images/reminder/repeat.svg">
            <select [formControl]="reminderForm.controls.frequencyId">
                <option class="select-first" disabled>
                    <div translate>reminder.repeat</div>
                </option>
                <option *ngFor="let c of frequency$ | async " [ngValue]="c.id" class="op">
                    <div>{{c.name}}</div>
                </option>
            </select>
        </div>

        <p class="mini-title" translate>reminder.recipients</p>
        <div class="recipient">
            <div class="user" *ngFor="let u of users.slice(0, maxOptionsToShow) ">
                <img class="contact-img" src="/assets/images/reminder/contact.svg">
                <p>{{u.firstName}}</p>
                <p> {{u.lastName}}</p>
                <img class="pointer" src="/assets/images/reminder/xx.svg" (click)="deletUser(u)">
            </div>
            <p *ngIf="users.length>maxOptionsToShow">...</p>
        </div>
        <textarea
            placeholder="{{'reminder.placeholder'| translate}}&#10;{{'reminder.placeholder2'| translate}}&#10;&#10;{{'reminder.placeholder3'| translate}}"
            class="textarea" [formControl]="reminderForm.controls.content"></textarea>
    </div>
    <!-- not in amdocs -->
    <!-- <div class="custom-checkbox">
        <div class="choose" (click)="appproval()" [ngClass]="{'selected': reminderForm.controls.isApproval.value }">
            <div class="inner-selected">
                <img src="/assets/images/auto-fill/vi.svg">
            </div>
        </div>
        <p (click)="appproval()" translate>reminder.isApprovalTitle</p>
    </div> -->
    <div class="footer">
        <img src="/assets/images/reminder/vectore.svg">
        <div class="btn-warp">
            <div class="cancel pointer" (click)="cancel()" translate>reminder.cancel</div>
            <div class="save pointer" (click)="save()" translate>reminder.save</div>
        </div>
    </div>

</div>